__webpack_require__.p = "https://hubinfo.affinity.io/";